var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-row',{staticClass:"d-flex justify-content-center"},[_c('h1',[_vm._v("Resource Detail")]),_c('educational-item-detail',{attrs:{"uuid":_vm.uuid}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }